import {
  ArrowLeftRight, BadgeCheck, BellRing, Boxes, Bug, Building2, CalendarClock, CheckSquare, ClipboardCheck,
  ClipboardList, Database, Droplets, Factory, FileCheck2, HandCoins, Stamp, BadgeIndianRupee, Receipt, Truck, FileMinus, FileSignature, FileType2, FlaskConical, GitBranch, Globe2, Handshake, HardHat, Heater,
  Network,
  History, Inbox, KeySquare, Languages, LayoutDashboard, ListChecks, Map, MapPin, MessageSquareWarning, MessagesSquare, Pickaxe, RadioTower,
  ReceiptIndianRupee, Ruler, Satellite, Scale, Scissors,
  SearchCheck, Send, Settings, Share2, ShieldAlert, ShieldCheck, Siren, SlidersHorizontal, SprayCan, Sprout, Timer, Trees, UserPlus,
  Users, Users2, UsersRound,
  type LucideIcon,
} from 'lucide-react';

/**
 * Name to component, for the icon names in `src/lib/navItems.ts`.
 *
 * The manifest holds names rather than components so it stays free of React and can be
 * imported by the tests under `node --test`. This is the only place that turns one into the
 * other, and an unknown name falls back rather than crashing a whole menu over a typo.
 *
 * Exactly the icons the menu names, and no more: a lucide import ships its paths whether or not
 * anything draws it, so the fourteen left behind by the prototype screens went with them.
 */
const ICONS: Record<string, LucideIcon> = {
  ArrowLeftRight, BadgeCheck, BellRing, Boxes, Bug, Building2, CalendarClock, CheckSquare, ClipboardCheck,
  ClipboardList, Database, Droplets, Factory, FileCheck2, HandCoins, Stamp, BadgeIndianRupee, Receipt, Truck, FileMinus, FileSignature, FileType2, FlaskConical, GitBranch, Globe2, Handshake, HardHat, Heater,
  Network,
  History, Inbox, KeySquare, Languages, LayoutDashboard, ListChecks, Map, MapPin, MessageSquareWarning, MessagesSquare, Pickaxe, RadioTower,
  ReceiptIndianRupee, Ruler, Satellite, Scale, Scissors,
  SearchCheck, Send, Settings, Share2, ShieldAlert, ShieldCheck, Siren, SlidersHorizontal, SprayCan, Sprout, Timer, Trees, UserPlus,
  Users, Users2, UsersRound,
};

export function NavIcon({ name, size = 16 }: { name: string; size?: number }) {
  const Icon = ICONS[name] ?? LayoutDashboard;
  return <Icon className="nav-icon" size={size} />;
}
